<script setup lang="ts">
import type { Swiper } from 'swiper/types';
import type { Point } from '.';

defineProps<{ swiper: Swiper | undefined }>();

const heading = 'Sauny & Regenerace';
const description =
  'Nabízíme několik typů saun určených k regeneraci po sportovním výkonu i k celkovému uvolnění těla. Pravidelné saunování podporuje imunitu, zlepšuje prokrvení svalů a pomáhá odbourávat stres. Prostor saun je navržen tak, aby poskytoval klidné prostředí pro odpočinek a načerpání nové energie po tréninku.';
const points: Point[] = [
  { text: 'Podporuje regeneraci svalů po tréninku', icon: 'icon:muscle' },
  { text: 'Posiluje imunitu a pomáhá odbourávat stres', icon: 'icon:immunity' },
];
const linkSlug = 'Zjistit více';
</script>

<template>
  <div
    class="gap-r12 lg:gap-r18 text-client-black flex w-full flex-col xl:w-[42%]"
  >
    <div class="gap-r6 flex flex-col">
      <AppHeading tag="h2">{{ heading }}</AppHeading>
      <div class="gap-r5 flex flex-col">
        <AppParagraph>{{ description }}</AppParagraph>
        <div class="gap-r3 flex flex-col">
          <ServicesRelaxSaunaHeaderPoint
            v-for="(point, i) in points"
            :key="i"
            :point
          />
        </div>
      </div>
    </div>

    <div class="flex items-center justify-between">
      <AppLink type="button" to="/sauny" :opts="{}">
        {{ linkSlug }}
      </AppLink>
      <AppSwiperControls v-if="swiper" :swiper />
    </div>
  </div>
</template>
